import React, { useState, useEffect, useRef } from "react";
//import qs from 'qs';
import axios from "axios";
import { BiDownArrowAlt, BiError } from "react-icons/bi";
import { MdLocalGasStation } from "react-icons/md";
import { SlSettings } from "react-icons/sl";
// import DropDown from "../DropDown";
import Modal from "../Modal";
import Spinner from "../Spinner";
import { TokenListButton, TransactButton } from "../Buttons";
import { useBalance } from "wagmi";
import { ethers } from 'ethers';
import TokenComponent from "../TokenComponent";
//import Erc20 from '../engine/erc20.json';
// import tokens from "../../res/tokens";

const style = {
	parentBgColor: `bg-sky-900/10`,
	swapBorderColor: `border-4 border-[#030a1d]`,
	inputSectionColor: `bg-sky-900/30`,
	inputSection: `h-[60px] flex flex-row items-center rounded-2xl transition-all duration-500
        outline-none focus-within:outline-1 focus-within:outline-sky-600`,
	input:
		"pl-4 h-full w-[70%] font-leaner font-bold text-4xl outline-none text-gray-400 bg-transparent selection:bg-sky-400/40 selection:text-white",
};

const slippages = [0.5, 1, 1.5, 2, 3];
const fills = [true, false]; // push button
const receiversWallet = ["my wallet", "new wallet"]; //

const Swap = ({ walletAddress, setSwapRoutes }) => {
	const [fValue, setFromValue] = useState(0.0);
	const [tValue, setToValue] = useState(0.0);
	const [isCalculating, setIsCalculating] = useState(false);
	const [fToken, setFromToken] = useState();
    const [tToken, setToToken] = useState();
	const [isFromCurrencyModalVisible, setIsFromCurrencyModalVisible] =
		useState(false);
	const [isToCurrencyModalVisible, setIsToCurrencyModalVisible] =
		useState(false);
	const [liquidityProviders, setLiquidityProviders] = useState([]);
	const [liquidityProvider, setLiquidityProvider] = useState("");
	//const [swapOrders, setSwapOrders] =useState({});
	const [estimatedGas, setEstimatedGas] = useState(0);
	//const [spender, setSpender] = useState(''); // default slippage is 0.5%
	const [fee, setFee] = useState(1); // transaction fee for the dex
	// const [qoute, setQoute] = useState({});
	const [validatedValue, setValidatedValue] = useState(0.0);
	const [dexAddress, setDexAddress] = useState("");
	//const [approvedSpender, SetApprovedSpender] = useState('');
	//const [approvedAllowance, setApprovedAllowance] = useState(0.0);
	const [receiver, setReceiver] = useState("");
	const [partialFill, setPartialFill] = useState(fills[1]);
	const [isSettingsVisible, setIsSettingsVisible] = useState(false);
	const [slippage, setSlippage] = useState(slippages[0]); // default slippage is 0.5% // meaning the user will loss  0.5 percent of their asset if you cancel a transaction
	const [toAnotherWallet, setToAnotherWallet] = useState(false); // true or false state
	const [swapStatus, setSwapStatus] = useState({ status: "", message: "" });
	const [quoteError, setQuoteError] = useState({ status: "", message: "" });

	const [allTokens, setAllTokens] = useState();

	let axiosCancelToken = useRef(null);

	//const signer = useSigner();
	const balance = useBalance({ addressOrName: walletAddress });
	const [receiverWallet, setReceiverWallet] = useState(receiversWallet[0]);

	//* This is just for the Token list Modal
	// filtering fTokens and tTokens to not display each other at the same time
	const [filteredfTokens, setFilteredfTokens] = useState();
	const [filteredtTokens, setFilteredtTokens] = useState();

	function filterTokens() {
		let filteredFTokens = allTokens.filter((filter) => {
			return filter.symbol.toLowerCase() !== tToken.symbol.toLowerCase();
		});
		setFilteredfTokens(filteredFTokens);
		let filteredTTokens = allTokens.filter((filter) => {
			return filter.symbol.toLowerCase() !== fToken.symbol.toLowerCase();
		});
		setFilteredtTokens(filteredTTokens);
	}

	function onFromValueChanged(e) {
		// setFromValue((existingValue) =>
		//     e.target.validity.valid ? e.target.value : existingValue
		// );
        
        if (e.target.validity.valid) {
            setToValue(0);
            setFromValue(e.target.value);
            let parsed = ethers.utils.parseUnits(e.target.value, fToken.decimals.toString());
            // eslint-disable-next-line no-undef
            let validBigNumber = BigInt(parsed).toString();
            setValidatedValue(validBigNumber);
		}
	}

    async function getPrice() {
        setSwapStatus({ status: "inprogress", message: "Calculating" });
		if (fValue === "0" || Number(fValue) === 0 || fValue.length <= 0) {
			//* since fValue is a string
			setToValue(0);
            setSwapRoutes([]);
            setSwapStatus({ status: "", message: "" });
			return;
		}

		if (axiosCancelToken.current) {
			axiosCancelToken.current.cancel();
			console.warn("request cancelled");
		}

		axiosCancelToken.current = axios.CancelToken.source();

		// setFee(1.5); //" dex aggregator fee"; // e.g 1.5 to mean 1.5%;

		if (!fToken.address || !tToken.address || !validatedValue || !fee) {
			console.log("Please fill in the required fields");
		}
		try {
			// axios.get(`https://api.1inch.io/v4.0/1/quote?fromTokenAddress=${fToken.address}&toTokenAddress=${tToken.address}&amount=${validatedValue}&fee=${fee}&slippage=${slippage}`).then((response)=>{
			axios
				.get(
					`https://api.1inch.io/v4.0/1/quote?fromTokenAddress=${fToken.address}&toTokenAddress=${tToken.address}&amount=${validatedValue}&fee=${fee}&slippage=${slippage}`,
					{ cancelToken: axiosCancelToken.current.token }
				)
				.then((response) => {
					// setQoute(response.data);
					// // qoute?.protocols?.[0].map((route)=>console.info('route',route[0].name))
					//* routing display
					let routes = [];
					response.data?.protocols?.[0].forEach((route) => {
						routes.push(route);
						// console.log('rr',route)
					});
					setSwapRoutes(routes); // send the routes to the SwapRoute component through Layout

					// console.info("response", response.data);
                    let rawValue = response.data.toTokenAmount;
					//    let value = rawValue.toFixed(4);
					// eslint-disable-next-line no-undef
					let value = rawValue / 10 ** tToken.decimals;
					setToValue(value.toString());
					let gas = response.data.estimatedGas;
					setEstimatedGas(gas);
                    setQuoteError({ status: "", message: "" });
                    setSwapStatus({ status: "", message: "" });
                }).catch((error) => {
                    setQuoteError({ status: "400", message: error.response?.data.description });
                    setSwapStatus({ status: "", message: "" });
                })
			setIsCalculating(false); // show calculating
		} catch (error) {
            setIsCalculating(false); // show calculating
            setSwapStatus({ status: "", message: "" });
			// console.log(error);
		}

		setTimeout(() => {
			axiosCancelToken.current = null;
		}, 1500);
    }

	/*
 ====================================================================
        The Swap function
 ====================================================================
*/
	async function swapitToOwnAddress() {
		if (!walletAddress || balance <= 0 || !fToken || !tToken || fValue <= 0) {
			//if (!walletAddress || fToken <= 0 || !tToken) {
			console.warn("One or more required fields are empty");
			if (!walletAddress)
				setSwapStatus({ status: 309, message: "Wallet not connected" });
			if (!fValue) setSwapStatus({ status: 309, message: "Enter swap amount" });
			if (balance <= 0)
				setSwapStatus({ status: 400, message: "Insufficient funds" });

			return;
		}
		setDexAddress("0x8D8f2AfAf11DD22BAa54C7102572BEf7f17a92e0");
		// const swapNow = await axios.get(
		await axios
			.get(
				`https://api.1inch.io/v4.0/1/swap?fromTokenAddress=${fToken.address}&toTokenAddress=${tToken.address}&amount=${validatedValue}&fromAddress=${walletAddress}&slippage=${slippage}&referrerAddress=${dexAddress}&fee=${fee}&allowPartialFill=${partialFill}`
			)
			.then((res) => {
				let success = {
					status: res.response.status,
					message: res.response.statusText,
				};
				setSwapStatus(success);
			})
			.catch((err) => {
				let error = {
					status: err.response.status,
					message: err.response.statusText,
				};
				console.log(err.response);
				setSwapStatus(error);
			});
		// console.log(swapNow.data);
	}

	async function swapitToAnotherDestination() {
		if (!walletAddress || !receiver || balance <= 0 || !fToken || !tToken) {
			//if (!walletAddress || fToken <= 0 || !tToken) {
			console.warn("One or more required fields are empty");
			if (!walletAddress)
				setSwapStatus({ status: 309, message: "Wallet not connected" });
			if (!receiver)
				setSwapStatus({ status: 309, message: "Specify receiver's address" });
			if (!fValue) setSwapStatus({ status: 309, message: "Enter swap amount" });
			if (balance <= 0)
				setSwapStatus({ status: 400, message: "Insufficient funds" });
			return;
		}
		setDexAddress("0x8D8f2AfAf11DD22BAa54C7102572BEf7f17a92e0");

		//https://api.1inch.io/v4.0/1/swap?fromTokenAddress=0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE&toTokenAddress=0x111111111117dc0aa78b770fa6a738034120c302&amount=10000000000000000&fromAddress=0x4922Dbe0b333dbF45C7834823B699ba61C847E6A&slippage=1&destReceiver=0x47Ac7F7c0fF4a41620635e44740914AC2eBdE5f3&referrerAddress=0x05301d500C789bd59aC307Bef714d10EbF22C1e3&fee=1.5&allowPartialFill=true
		// const swapNow = await axios.get(
		await axios
			.get(
				`https://api.1inch.io/v4.0/1/swap?fromTokenAddress=${fToken.address}&toTokenAddress=${tToken.address}&amount=${validatedValue}&fromAddress=${walletAddress}&slippage=${slippage}&destReceiver=${receiver}&referrerAddress=${dexAddress}&fee=${fee}&allowPartialFill=${partialFill}`
			)
			.then((res) => {
				let success = {
					status: res.response.status,
					message: res.response.statusText,
				};
				setSwapStatus(success);
			})
			.catch((err) => {
				let error = {
					status: err.response.status,
					message: err.response.statusText,
				};
				console.log(err.response);
				setSwapStatus(error);
			});
		// console.log(swapNow.data);
	}

	function swapValues() {
		let tmpToken = fToken;
		setFromToken(tToken);
		setToToken(tmpToken);
	}

	//================={Get qoute}===============
	//   useEffect(()=> {
	//     getPrice();
	//     }, []);

	// useEffect(() => {
	// 	const delayDebounce = setTimeout(() => {
	// 		getPrice();
	// 	}, 1000);
	// 	return () => clearTimeout(delayDebounce);
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, []);

	//================={Get qoute}===============

	//==============={useEffect Blocks}=================================

	//================={Get Liquidity providers}===============

	useEffect(() => {
		axios.get("https://api.1inch.io/v4.0/1/tokens").then((response) => {
			// let allTokens = response.data.tokens;
			let allTokenKeys = Object.keys(response.data.tokens);
			let allTs = allTokenKeys.map((key) => response.data.tokens[key]);

			// console.info('allTokens',allTs[0])
            
			setAllTokens(allTs);
			// setAllTokens(tokens);
		});

		axios
			.get("https://api.1inch.io/v4.0/1/liquidity-sources")
			.then((response) => {
				//setSwapOrders(response.data);
				//let orders = response.data.title;
				let orders = response.data.protocols.title;
				//setSwapOrders(response.data.title);
				setLiquidityProviders(orders);
				// console.log("lp", orders);
			});

		setFee(1.5);
	}, []);

	useEffect(() => {
		if (allTokens !== undefined) {
			setFromToken(allTokens[0]);
            setToToken(allTokens[1]);
        }
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [allTokens]);

	useEffect(() => {
        fToken !== undefined && filterTokens();
        setSwapStatus({ status: "", message: "" });

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fToken, tToken]);

	useEffect(() => {
		setIsCalculating(true); // show calculating

		fValue !== 0 && getPrice();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fToken, tToken, fValue, slippage]);

	return (
		<div>
			<section className="flex flex-col items-center">
				<div className={`px-4 py-3 rounded-3xl ${style.parentBgColor}`}>
					<div className="font-bold text-lg text-gray-200">
                        <span>Swap</span>
                        {quoteError.status && (
                            <div className="px-2 py-1 w-full flex flex-row gap-6 justify-center items-center error rounded-lg" onClick={() => setQuoteError({ status: "", message: "" })}>
                                <span className="text-2xl"><BiError/></span>
                                <div>{quoteError.message}</div>
                            </div>
                        )}
					</div>

					<section className="relative mt-4">
						<div className="flex flex-col gap-3">
							<div
								className={`${style.inputSection} ${style.inputSectionColor}`}
							>
								<input
									type="text"
									className={style.input}
                                    pattern="[0-9]*.[0-9]*"
									placeholder="0.0"
									value={fValue}
									onChange={onFromValueChanged}
								/>

								<div className="ml-auto mr-2">
									{/* <DropDown
										list={tokens}
										keyName="symbol"
										onChange={onFromNameChanged}
										selected={fname.symbol}
									/> */}
									<TokenListButton
										selectedTokenName={fToken?.symbol}
										modalVisible={isFromCurrencyModalVisible}
										toggleModal={setIsFromCurrencyModalVisible}
										selectedTokenIcon={fToken?.logoURI}
									/>
								</div>
							</div>

							<div
								className={`absolute top-[40%] left-[50%] rounded-full text-2xl text-gray-400
                                    bg-[#0d2a43] ${style.swapBorderColor}
                                    cursor-pointer transition-transform duration-300 hover:scale-125 hover:rotate-180 hover:text-sky-400`}
								onClick={swapValues}
							>
								<BiDownArrowAlt />
							</div>

							<div
								className={`${style.inputSection} ${style.inputSectionColor}`}
							>
								<input
									type="text"
									className={style.input}
									pattern="[0-9]*.[0-9]*"
									placeholder="0.0"
									value={tValue}
									disabled={true}
								/>
								<div className="ml-auto mr-2">
									{/* <DropDown
										list={tokens}
										keyName="symbol"
										onChange={onToNameChanged}
										selected={tname.symbol}
									/> */}
									<TokenListButton
										selectedTokenName={tToken?.symbol}
										modalVisible={isToCurrencyModalVisible}
										toggleModal={setIsToCurrencyModalVisible}
										selectedTokenIcon={tToken?.logoURI}
									/>
								</div>
							</div>

							{/* {receiverWallet && receiverWallet === "new wallet" ? (
								<div
									className={`${style.inputSection} ${style.inputSectionColor}`}
								>
									<input
										type="text"
										className={style.input}
										pattern="[0-9]*.[0-9]*"
										placeholder="0.0"
										value={receiver}
										//onChange={setReceiver({receiver: e.target.value})}
										onChange={(e) => setReceiver(e.target.value)}
									/>
								</div>
							) : null} */}
						</div>
					</section>

					<section className="mt-2 w-full flex">
						<span
							className="ml-auto text-xl text-gray-300/50 cursor-pointer transition-transform duration-500 hover:rotate-90"
							onClick={() => setIsSettingsVisible(!isSettingsVisible)}
						>
							<SlSettings />
						</span>
					</section>

					{isSettingsVisible && (
						<>
							{/* slippage section */}
							<section
								className="mt-3 w-fit h-fit flex flex-row gap-2 items-center text-gray-200/50"
								onChange={(e) => {
									setSlippage(e.target.value);
								}}
							>
								<span className="text-sm">Slippage:</span>
								<div className="flex flex-row flex-wrap gap-2">
									{slippages.map((slp) => (
										<label key={slp}>
											<input
												type="radio"
												id="slippage"
												name="slippage"
												value={slp}
												className="peer sr-only"
											/>
											<span
												className={`px-2 py-1 rounded-md cursor-pointer ${
													slp === slippage
														? "bg-black text-gray-200"
														: "bg-black/50 text-gray-200/30"
												} border border-transparent peer-hover:border-gray-200/30 peer-checked:bg-black peer-checked:hover:border-transparent peer-checked:text-gray-200`}
											>
												{slp} %
											</span>
										</label>
									))}
								</div>
							</section>

							{/* send to another wallet */}
							<section className="mt-4 flex flex-row flex-wrap gap-2 items-center">
								<span class="text-sm font-medium text-gray-200/50">
									Send to another wallet
								</span>
								<label
									htmlfor="to-another-wallet"
									class="inline-flex relative items-center cursor-pointer"
								>
									<input
										type="checkbox"
										checked={toAnotherWallet}
										id="to-another-wallet"
										name="to-another-wallet"
										class="sr-only peer"
									/>
									<div
										class="w-11 h-6 bg-gray-200/30 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-black"
										onClick={() => setToAnotherWallet(!toAnotherWallet)}
									></div>
								</label>

								{toAnotherWallet && (
									<div className="input-section">
										<input
											type="text"
											className="input-1"
											placeholder="wallet address"
											value={receiver}
											onChange={(e) => setReceiver(e.target.value)}
										/>
									</div>
								)}
							</section>
						</>
					)}

					<section className="flex flex-row justify-between">
						{liquidityProvider && (
							<section className="my-2 flex">
								<div className="mr-auto text-sm text-gray-400">
									{isCalculating ? `Getting providers...` : liquidityProvider}
								</div>
							</section>
						)}

						{fValue > 0 && (
							<section className="my-2 flex">
								<div className="ml-auto text-sm text-gray-400">
									{isCalculating ? (
										"Fetching best price..."
									) : (
										<span className="flex flex-row gap-3 items-center">
											<span className="text-lg">
												<MdLocalGasStation />
											</span>
											<span>{(estimatedGas/10**9).toString()} Gwei</span>
										</span>
									)}
								</div>
							</section>
						)}
					</section>

					{/* swap status section */}
					{swapStatus.status !== "" && swapStatus.status !== 'inprogress' && (
						<section
							className={`mt-3 px-3 py-2 w-full h-fit flex flex-row gap-6 justify-center rounded-lg ${
								swapStatus.status === 200
									? "success"
									: swapStatus.status === 309
									? "warn"
									: "error"
							}`}
							onClick={() => setSwapStatus({ status: "", message: "" })}
						>
							{swapStatus.message}
						</section>
					)}

					<section className="mt-4 flex justify-center">
						{receiverWallet && receiverWallet === "my wallet" ? (
							<TransactButton
								disabled={
									//walletAddress.length <= 5 || fValue === 0 ? true : false
									fValue === 0 ? true : false
								}
								onClick={() => {
									if (toAnotherWallet) {
										swapitToAnotherDestination();
									} else {
										swapitToOwnAddress();
									}
								}}
							>
                                {swapStatus.status !=='inprogress'? 'Swap' : <Spinner/>}
							</TransactButton>
						) : (
							<TransactButton
								disabled={
									//walletAddress.length <= 5 || fValue === 0 ? true : false
									fValue === 0 ? true : false
								}
								onClick={() => swapitToAnotherDestination()}
							>
								Swap
							</TransactButton>
						)}
						{/* Only double-equal checking is used this checks all zero values
                        including 0.0 and without type conversion */}
						{/* eslint-disable-next-line eqeqeq */}
					</section>
				</div>
			</section>


			{/*
            ====================================================================
                From & To Currency Modals
            ====================================================================
            */}
			<Modal
				visible={isFromCurrencyModalVisible}
				setVisible={setIsFromCurrencyModalVisible}
				title="Token to convert from"
			>
				<div className="mb-6 input-section">
					<input
						type="text"
						className="input-1"
						placeholder="search token"
						onChange={(e) => {
							if (e.target.value === "") {
								setFilteredfTokens(allTokens);
								return;
							}

                            let ffToken = allTokens.filter(({symbol}) => {
                                    // filter.symbol.toLowerCase() === e.target.value.toLowerCase()
                                    return symbol.toLowerCase().includes(e.target.value.toLowerCase())
                            });
							if (ffToken !== null) {
								setFilteredfTokens(ffToken);
							}
							// console.info(ffToken);
						}}
					/>
				</div>
				<div className="w-[500px] h-fit max-h-[400px] overflow-y-scroll">
					<div className="grid grid-cols-3 grid-flow-row gap-8">
						{filteredfTokens?.map((token, idx) => (
							// <div
							// 	key={idx}
							// 	className={`px-3 py-2 bg-black/30 rounded-lg border ${
							// 		token.symbol === fToken.symbol
							// 			? "border-gray-100 text-gray-100"
							// 			: "border-white/10 text-gray-300"
							// 	} cursor-pointer hover:text-gray-100 hover:border-gray-100`}
							// 	onClick={() => {
							// 		setFromToken(token);
							// 		setIsFromCurrencyModalVisible(false);
							// 	}}
							// >
							// 	<img src={token.logoURI} alt="" className="w-6 h-6" />
							// 	<span>{token.symbol}</span>
							// </div>
                            <TokenComponent key={idx} currentItem={token}
                                selectedToken={fToken} setSelectedToken={setFromToken}
                                setIsTokenModalVisible={setIsFromCurrencyModalVisible} />
						))}
					</div>
				</div>
			</Modal>
			<Modal
				visible={isToCurrencyModalVisible}
				setVisible={setIsToCurrencyModalVisible}
				title="Token to convert to"
			>
				<div className="mb-6 input-section">
					<input
						type="text"
						className="input-1"
						placeholder="search token"
						onChange={(e) => {
							if (e.target.value === "") {
								setFilteredtTokens(allTokens);
								return;
							}

                            let ttToken = allTokens.filter(({symbol}) => {
                                return symbol.toLowerCase().includes(e.target.value.toLowerCase())
                        });
							if (ttToken !== null) {
								setFilteredtTokens(ttToken);
							}
						}}
					/>
				</div>
				<div className="w-[500px] h-fit max-h-[400px] overflow-y-scroll">
					{/* <div className="flex flex-row flex-wrap gap-8"> */}
					<div className="grid grid-cols-3 grid-flow-row gap-8">
						{filteredtTokens?.map((token, idx) => (
							// <div
							// 	key={idx}
							// 	className={`px-3 py-2 bg-black/30 rounded-lg border ${
							// 		token.symbol === tToken.symbol
							// 			? "border-gray-100 text-gray-100"
							// 			: "border-white/10 text-gray-300"
							// 	} cursor-pointer hover:text-gray-100 hover:border-gray-100`}
							// 	onClick={() => {
							// 		setToToken(token);
							// 		setIsToCurrencyModalVisible(false);
							// 	}}
							// >
							// 	<img src={token.logoURI} alt="" className="w-6 h-6" />
							// 	<span>{token.symbol}</span>
							// </div>
                            <TokenComponent key={idx} currentItem={token}
                                selectedToken={tToken} setSelectedToken={setToToken}
                                setIsTokenModalVisible={setIsToCurrencyModalVisible} />
						))}
					</div>
				</div>
			</Modal>
			<Modal title="Slippage">
				<div className="w-[500px] h-fit max-h-[400px] overflow-y-scroll">
					<div className="flex flex-row flex-wrap gap-8">
						{slippages?.map((s, idx) => (
							<div
								key={idx}
								className={`px-3 py-2 bg-black/30 rounded-lg border cursor-pointer hover:text-gray-100 hover:border-gray-100`}
								onClick={() => {
									setSlippage(s);
								}}
							></div>
						))}
					</div>
				</div>
			</Modal>
			<Modal title="Choose LiquidityProvider">
				<div className="w-[500px] h-fit max-h-[400px] overflow-y-scroll">
					<div className="flex flex-row flex-wrap gap-8">
						{liquidityProviders?.map((l, idx) => (
							<div
								key={idx}
								className={`px-3 py-2 bg-black/30 rounded-lg border cursor-pointer hover:text-gray-100 hover:border-gray-100`}
								onClick={() => {
									setLiquidityProvider(l);
								}}
							></div>
						))}
					</div>
				</div>
			</Modal>
			<Modal title="Allow Partial Fill">
				<div className="w-[500px] h-fit max-h-[400px] overflow-y-scroll">
					<div className="flex flex-row flex-wrap gap-8">
						{fills?.map((f, idx) => (
							<div
								key={idx}
								className={`px-3 py-2 bg-black/30 rounded-lg border cursor-pointer hover:text-gray-100 hover:border-gray-100`}
								onClick={() => {
									setPartialFill(f);
								}}
							></div>
						))}
					</div>
				</div>
			</Modal>
			<Modal title="Choose Receiver">
				<div className="w-[500px] h-fit max-h-[400px] overflow-y-scroll">
					<div className="flex flex-row flex-wrap gap-8">
						{receiversWallet?.map((r, idx) => (
							<div
								key={idx}
								className={`px-3 py-2 bg-black/30 rounded-lg border cursor-pointer hover:text-gray-100 hover:border-gray-100`}
								onClick={() => {
									setReceiverWallet(r);
								}}
							></div>
						))}
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default Swap;
